<template>
  <div class="page">
    <div class="page-content">

  		<page-nav-bar
        currentServiceName="MoneyRoad"
        :subNavTitle="$i18n.t('common.edit_item',
                      {itemname: $t('bank_accounts.bank_account_singular')})"
        :closePage="isSmartphone">
      </page-nav-bar>

      <div class="layoutTop"/>
       <div class="container-fluid">
         <div class="row">
           <div class="col-md-10 offset-md-1">
             <div class="panel21 panel-default">
               <div class="panel-heading">
                 <h4 class="content-block labelAccordionForm">
                   <img src="../../assets/static/images/icons/credit_cards.png" class="formIcon"/>
                     {{ $t('common.edit_item',
                       {itemname: $t('bank_accounts.bank_account_singular')}) }}
                 </h4>
               </div>
               <div class="form-group row">
                 <div class="col-sm-2 col-4 col-form-label labelAccordionForm">
                   <span class="color-red">* </span>
                   {{ $t('common.act') }}
                 </div>
                 <div class="col-sm-4 showSmallScreenOnly form-group" v-bind:class="colorBottomButton">
                   <div @click="countriesPicker($event)" class="button button-round button-inner-color buttonAccordionForm">
                     {{ $t('common.slct') }}
                   </div>
                 </div>
                 <div class="col-sm-12 showSmallScreenOnly">
                   <input
                      @click="countriesPicker($event)"
                      class="form-control"
                      id="ListCountry"
                      type="text"
                      v-model="zoneCode"
                      :placeholder="$i18n.t('zoneCodes.slct_zone')"
                      readonly>
                   </input>
                 </div>
                 <div class="col-sm-10 showLargeScreenOnly">
                   <select class="form-control" id="sel4" readonly v-model="zone">
                     <option value="" selected hidden>{{ $t('zoneCodes.slct_zone') }}</option>
                     <option v-for="country in countries"
                      :key="country.label"
                      :value="country"
                      :disabled="country.disabled"
                      :selected="country.selected">
                      {{ $t('zoneCodes.' + country.label)}}
                     </option>
                   </select>
                 </div>
               </div>
               <div
                 class="form-group row"
                 v-for="accountLabel in zone.accountLabel">
                   <label class="col-4 col-sm-2 col-form-label">
                     <span class="color-red">* </span>{{ $t(accountLabel) }}</label>
                   <div class="col-8 col-sm-10">
                     <input
                       name="identifier"
                       class="form-control"
                       type="text"
                       :placeholder="$i18n.t(accountLabel)"
                       v-model="zone.values[accountLabel]">
                     </input>
                   </div>
               </div>
              <div class="form-group row">
                <div class="col-4 col-sm-2">Is default</div>
                <div class="col-8 col-sm-10">
                  <f7-input type="switch" :checked="isDefault" @change="switchDefault"></f7-input>
                </div>
              </div>
              </div>
             </div>
           </div>

         <div class="row">
          <div class="col-md-2 offset-md-9" v-bind:class="colorBottomButton">
            <button round title="Register" class="button-action firstButtonMarginTop" @click="editAccount">
              <i class="icon fa fa-save"></i>
              <span>{{ $t('common.sve') }}</span>
            </button>
          </div>
        </div>
                 </div>
       </div>
       <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>

<script>
import {validateAccountFormat} from '@/helpers/validator'
import {extractForeignIban, createForeignIban} from '@/helpers/format'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'
import _ from 'lodash'

export default {
  name: 'EditBankAccount',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      iban: '',
      name: '',
      id: 0,
      isDefault: true,
      zone: {},
      zoneCode: '',
      sortCode: '',
      accountNumber: '',
      isSmartphone: false,
      countries: '',
      countryPicker: ''
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.name = this.$settings.modifyAccount.name
    this.zoneCode = this.$settings.modifyAccount.zoneCode
    this.id = this.$settings.modifyAccount.id
    this.isDefault = this.$settings.modifyAccount.isDefault
    this.zone = _.cloneDeep(this.$engine.bankAccounts.getZoneData(this.$settings.modifyAccount.zoneCode))
    if (this.$settings.modifyAccount.isDefault === '0') {
      this.isDefault = false
    } else if (this.$settings.modifyAccount.isDefault === '1') {
      this.isDefault = true
    }

    /** TLV 19/03/2020
    * On extrait les donnees du faux IBAN en base en vraies donnees bancaires,
    * en fonction du pays, dans une variable locale appelee extractedBankData
    */
    let extractedBankData = {}
    if (this.zoneCode !== '' && this.$settings.modifyAccount.iban !== '') {
      extractedBankData = extractForeignIban(this.$settings.modifyAccount.iban, this.zoneCode)
    }
    /** TLV 19/03/2020
    * On cree une variable locale json, qui va etre integree dans this.zone et dans that.countries,
    * qui contient les valeurs actuelles du json pour l'utilisateur selectionne
    */
    let datavalues = {}
    for (var bankData in extractedBankData) {
      datavalues[extractedBankData[bankData].labelId] = extractedBankData[bankData].value
    }
    this.zone.values = datavalues
    let that = this
    let label = []

    that.countries = _.cloneDeep(this.$engine.bankAccounts.getZoneCode())
    for (var country in that.countries) {
      if (that.countries[country].label === this.zoneCode) {
        that.countries[country].values = datavalues
      }
    }
    that.countries.forEach((x, y) => {
      label.push(x.label)
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = this.$i18n.t(p.value[0])
        that.zone = that.countries.filter(function (country) {
          return country.label === p.value[0]
        })[0]
      }
    })
  },
  methods: {
    switchDefault (obj) {
      this.isDefault = obj.target.checked
    },
    editAccount () {
      let defaultValue = ''
      if (this.isDefault === false) {
        defaultValue = '0'
      } else if (this.isDefault === true) {
        defaultValue = '1'
      }
      let that = this

      // Check input formats
      if (this.name === '') {
        this.$f7.alert('Choose a name for your new account', 'Account name missing')
        return
      }
      // Check input formats
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t('errors.change_to_valid',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        }
      }

      /* TLV 18/03/2020
      * Cr�ation d'un "faux IBAN" pour enregistrer en base
      */
      let localIban = createForeignIban(this.zone)

      // Edit account
      this.$engine.bankAccounts
        .update({
          id: this.id,
          name: this.name,
          iban: localIban,
          qxban: '',
          isDefault: defaultValue,
          zoneCode: this.zoneCode
        })
        .then(() => {
          this.$f7.modal({
            title: this.$i18n.t('success.updated_success', {data: this.$i18n.t('bank_accounts.bank_account_singular')}),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.name = ''
            that.iban = ''
            that.id = 0
            loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          this.handleError(err) // mixins errorHandlerMixins
        })
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>

<style>
.container {
    width: 100%;
    height: auto;
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    /*margin-bottom: 5%;*/
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// CMEditBankAccount.vue?6041e41a